import { motion } from 'framer-motion';
import PageWrapper from '../layout/PageWrapper';
import AnimatedBackground from '../layout/AnimatedBackground';
import ClassroomPanoramaTabs from '../features/panorama/ClassroomPanoramaTabs';

export default function Classrooms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AnimatedBackground type="floating-shapes" className="fixed inset-0 -z-10" />
      
      <PageWrapper>
        {/* Header Section */}
        <motion.section
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="py-16 bg-gradient-to-br from-amber-50 to-yellow-100 rounded-2xl mb-16"
        >
          <div className="max-w-6xl mx-auto px-6">
            <h1 className="text-4xl md:text-5xl font-bold text-dblue text-center mb-6">
              Our Classrooms
            </h1>
            <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto text-center text-lg">
              Step inside our thoughtfully designed learning spaces where children discover, play, and grow. 
              HCC is a Group Licensed Centre governed by
Vancouver Coastal Health (VCC). Our Centre
currently has six classroom 
            </p>
          </div>
        </motion.section>

        {/* Panoramic Classroom Tours */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-16"
        >
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-dblue mb-4">
              360° Virtual Classroom Tours
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Explore all of our classrooms with immersive 360° tours. Click on any classroom tab below 
              to see how we've designed each space for different age groups and learning styles.
            </p>
          </div>
          
          <ClassroomPanoramaTabs />
        </motion.section>

        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="bg-white rounded-2xl shadow-lg p-8 text-center"
        >
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-dblue mb-6">Experience Our Classrooms in Person</h2>
            <p className="text-gray-600 leading-relaxed mb-8 text-lg">
              While our 360° tour gives you a great preview, nothing compares to seeing our classrooms 
              in action with children learning and playing. Schedule a visit to experience the energy 
              and joy of our learning environment firsthand.
            </p>
            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
            >
              <motion.a
                href="/enrollment"
                className="bg-yellow-500 text-black px-8 py-4 rounded-full font-semibold hover:bg-yellow-600 transition-colors duration-300 shadow-lg inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Schedule a Tour
              </motion.a>
              <motion.a
                href="/contact-us"
                className="bg-dblue text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-300 shadow-lg inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Learn More
              </motion.a>
            </motion.div>
          </div>
        </motion.section>
      </PageWrapper>
    </div>
  );
}


